import React from 'react';
import * as ReactBootstrap from 'react-bootstrap';

class ProjectSelector extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            sbProjectTitle: "Please select a Project",
        };
        this.projectChangeHandler = this.projectChangeHandler.bind(this);
        this.loadProjects = this.loadProjects.bind(this);
    }
    componentDidMount() {
        this.loadProjects();
    }
    loadProjects() {
        this.props.projectService.loadProjects()
        .then(result => {
            this.props.stateManagementService.updateProjects(result).catch(error => {
                console.error('Failed loading projects:', error);
            });
        })
        .catch(error => {
            console.error('Failed loading projects:', error);
        });
    }
    projectChangeHandler(project_id) {
        var projectChanged = (project_id != null && project_id != this.props.projectId)
        if (!projectChanged) {
            return;
        }
        const projectItem = this.props.projects.find(project => project.id == project_id);
        if (projectItem != null) {  
            this.setState({
                sbProjectTitle: projectItem.name,
            }, () => {
                this.props.onProjectChange(project_id);
            });
        }
    }
    render() {
        const { projects, projectId } = this.props;
        return (
            <>
                <ReactBootstrap.Dropdown onSelect={this.projectChangeHandler}>
                    <ReactBootstrap.Dropdown.Toggle variant="light" id="projects-drop-down">
                        {`${projectId || ''}${projectId ? ': ' : ''} ${this.state.sbProjectTitle}`}
                    </ReactBootstrap.Dropdown.Toggle>
                    <ReactBootstrap.Dropdown.Menu>
                        {projects != null && projects
                        .map((project, i) => (
                            <ReactBootstrap.Dropdown.Item key={project.id} eventKey={project.id}>
                            {`${project.id}: ${project.name}`}
                            </ReactBootstrap.Dropdown.Item>
                        ))}
                    </ReactBootstrap.Dropdown.Menu>
                </ReactBootstrap.Dropdown>
            </>
            );
        }
    }

export default ProjectSelector;